﻿import { format } from 'date-fns-tz';
import { pacificTimeZone } from './parse-from-pacific-timezone-date';

export const getISO8601PacificDate = (date: Date, time: string): string => {
  const dateString = format(date, 'yyyy-MM-dd');
  const timeOffset = getTimeOffset(date);
  return `${dateString}T${time}${timeOffset}`;
}

export const getISO8601PacificDateFromDateTime = (date: Date): string => {
  const dateString = format(date, `yyyy-MM-dd'T'HH:mm:ss`);
  const timeOffset = getTimeOffset(date);
  return `${dateString}${timeOffset}`;
}

const getTimeOffset = (date: Date): string => {
  const timeZone = format(date, 'z', { timeZone: pacificTimeZone });
  const timeOffset = timeZone === 'PDT' ? '-07:00' : '-08:00';
  return timeOffset;
}
